import { types } from 'mobx-state-tree';

export const MunicipalityModel = types.model('MunicipalityModel', {
  tenantId: types.string,
  displayName: types.maybe(types.string),
  icon: types.maybe(types.frozen()),
  logo: types.maybe(types.frozen())
});
